/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const NotFound = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg
    fill="none"
    viewBox="0 0 132 132"
    ref={ref}
    css={{
      color: "#F4F6F8",
      height: "132px",
      width: "132px",
    }}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M66 132c36.451 0 66-29.549 66-66 0-36.45-29.549-66-66-66C29.55 0 0 29.55 0 66c0 36.451 29.55 66 66 66z"
      clipRule="evenodd"
    />
    <path
      stroke="#424855"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.625}
      d="M83.938 50.25H48.062a1.75 1.75 0 0 0-1.75 1.75v28c0 .966.784 1.75 1.75 1.75h35.876a1.75 1.75 0 0 0 1.75-1.75V52a1.75 1.75 0 0 0-1.75-1.75zM59.438 59.32v3.617M72.563 59.32v3.617"
    />
    <path
      stroke="#424855"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.625}
      d="M55.5 73.321a11.1 11.1 0 0 1 10.138-5.22A13.422 13.422 0 0 1 76.5 73.32"
    />
    <path
      fill="#CAD0D8"
      fillRule="evenodd"
      d="M86.947 38.864c0 .627.472 1.136 1.053 1.136s1.053-.509 1.053-1.136v-1.811h1.81C91.492 37.053 92 36.58 92 36c0-.582-.509-1.053-1.136-1.053h-1.811v-1.81C89.053 32.508 88.58 32 88 32s-1.053.509-1.053 1.136v1.811h-1.81c-.628 0-1.137.471-1.137 1.053 0 .581.509 1.053 1.136 1.053h1.811v1.811zM15.947 73.864c0 .627.472 1.136 1.053 1.136s1.053-.509 1.053-1.136v-1.811h1.81C20.492 72.053 21 71.58 21 71c0-.582-.509-1.053-1.136-1.053h-1.811v-1.81C18.053 67.508 17.58 67 17 67s-1.053.509-1.053 1.136v1.811h-1.81c-.628 0-1.137.471-1.137 1.053 0 .581.509 1.053 1.136 1.053h1.811v1.811zM80.947 118.864c0 .627.472 1.136 1.053 1.136s1.053-.509 1.053-1.136v-1.811h1.81c.628 0 1.137-.472 1.137-1.053 0-.582-.509-1.053-1.136-1.053h-1.811v-1.81c0-.628-.472-1.137-1.053-1.137s-1.053.509-1.053 1.137v1.81h-1.81c-.628 0-1.137.471-1.137 1.053 0 .581.509 1.053 1.136 1.053h1.811v1.811zM115.947 57.864c0 .627.472 1.136 1.053 1.136s1.053-.509 1.053-1.136v-1.811h1.811c.627 0 1.136-.472 1.136-1.053 0-.582-.509-1.053-1.136-1.053h-1.811v-1.81c0-.628-.472-1.137-1.053-1.137s-1.053.509-1.053 1.136v1.811h-1.811c-.627 0-1.136.471-1.136 1.053 0 .581.509 1.053 1.136 1.053h1.811v1.811zM75.5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM26.5 61a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM37.5 17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM106.5 33a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM106.5 77a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM61.5 104a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM38.5 113a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM23.5 41a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23.5 39.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
      clipRule="evenodd"
    />
    <path
      fill="#CAD0D8"
      fillRule="evenodd"
      d="M58.5 31a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M58.5 29.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
      clipRule="evenodd"
    />
    <path
      fill="#CAD0D8"
      fillRule="evenodd"
      d="M29.5 95a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M29.5 93.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
      clipRule="evenodd"
    />
    <path
      fill="#CAD0D8"
      fillRule="evenodd"
      d="M107.5 100a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M107.5 98.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
      clipRule="evenodd"
    />
  </svg>
));
